// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DateFns = require("date-fns");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");

function ListingDetails(props) {
  let __titleClassName = props.titleClassName;
  let lastUpdated = props.lastUpdated;
  let titleClassName = __titleClassName !== undefined ? __titleClassName : "text-2xl font-medium text-zinc-800";
  let items = Stdlib_Array.keepSome([
    Stdlib_Option.map(props.timeOnTan, timeOnTan => [
      "Time on TAN",
      timeOnTan,
      false
    ]),
    Stdlib_Option.map(props.commission, commission => [
      "Concessions seller will consider",
      commission,
      false
    ]),
    Stdlib_Option.map(props.parkingSpots, parkingSpots => [
      "Parking Spaces",
      parkingSpots,
      false
    ]),
    Stdlib_Option.map(props.parkingDetails, parkingDetails => [
      "Parking Details",
      parkingDetails,
      false
    ]),
    Stdlib_Option.map(props.nextShowing, nextShowing => [
      "Next Showing",
      nextShowing,
      true
    ]),
    Stdlib_Option.map(props.expectedOnMls, expectedOnMls => [
      "Expected on MLS",
      expectedOnMls,
      true
    ]),
    Stdlib_Option.map(props.willShowBeforeMls, willShowBeforeMls => [
      "Will show before MLS",
      willShowBeforeMls,
      true
    ]),
    Stdlib_Option.map(props.willAcceptOffersBeforeMls, willAcceptOffersBeforeMls => [
      "Will accept offers before MLS",
      willAcceptOffersBeforeMls,
      true
    ]),
    Stdlib_Option.map(props.website, website => [
      "Website",
      website,
      false
    ])
  ]);
  let mobileTable = JsxRuntime.jsx("table", {
    children: JsxRuntime.jsx("tbody", {
      children: items.map(param => {
        let title = param[0];
        return JsxRuntime.jsxs("tr", {
          children: [
            JsxRuntime.jsx("td", {
              children: title,
              className: "w-1/3 p-4"
            }),
            JsxRuntime.jsx("td", {
              children: param[1],
              className: ""
            })
          ],
          className: "table-row even:bg-zinc-100"
        }, title);
      })
    }),
    className: "w-full divide-y divide-zinc-200 bg-white md:hidden"
  });
  let desktopTable = JsxRuntime.jsx("table", {
    children: JsxRuntime.jsx("tbody", {
      children: items.filter(param => !param[2]).map(param => {
        let title = param[0];
        return JsxRuntime.jsxs("tr", {
          children: [
            JsxRuntime.jsx("td", {
              children: title,
              className: "w-1/3 p-4"
            }),
            JsxRuntime.jsx("td", {
              children: param[1],
              className: ""
            })
          ],
          className: "table-row even:bg-zinc-100"
        }, title);
      })
    }),
    className: "w-full divide-y divide-zinc-200 bg-white hidden md:table"
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: "Listing details",
        className: titleClassName
      }),
      JsxRuntime.jsxs("div", {
        children: [
          mobileTable,
          desktopTable
        ],
        className: "rounded-lg border border-zinc-200 overflow-hidden mt-4"
      }),
      lastUpdated !== undefined ? JsxRuntime.jsx("div", {
          children: `Last updated ` + DateFns.formatDistance(lastUpdated, new Date()) + ` ago`,
          className: "my-4"
        }) : null
    ]
  });
}

let make = ListingDetails;

exports.make = make;
/* date-fns Not a pure module */
